import React from 'react';

const Card = ({ children, className }) => {
  return (
    <div className={`rounded-[10px] bg-white shadow-md ${className}`}>
      {children}
    </div>
  );
};

export default Card;
